if (!customElements.get('multicolumn-video-card')) {
  customElements.define(
    'multicolumn-video-card',
    class MulticolumnVideoCard extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        // 初始化
        // 获取VideoOverlay
        this.videoOverlay = document.querySelector('video-overlay');

        // 获取button play-button
        this.playButton = this.querySelector('.play-button');
        this.playButton.addEventListener('click', this.onClick.bind(this));
        
        

      }

      onClick() {
        // 打开视频弹窗
        this.videoOverlay.setVideoSrc(this.getAttribute('data-video-src'));
        this.videoOverlay.open();
      }

      
    }
  );
}
